import RedesignDescriptor from './common-elements-redesign';
import RefiveDescriptor from './common-elements-refive';
import connectDescriptor from './common-elements-canteen';
import companyKitchenDescriptor from './common-elements-companykitchen';
import aramarkDescriptor from './common-elements-aramark';
import BuildTypes from 'src/constants/BuildTypeConstants';
import Settings from 'src/Settings';
import {GiftItem} from 'src/types/snack/GiftItem';
// import DealModel from 'src/models/Moblico/Deal';
import {StyleProp, ViewStyle, TextStyle} from 'react-native';
import {Referral} from 'src/types/Referral';
const typeDescriber = {
  [BuildTypes.aramark]: aramarkDescriptor,
  [BuildTypes.canteen]: connectDescriptor,
  [BuildTypes.default]: RedesignDescriptor,
  [BuildTypes.companykitchen]: companyKitchenDescriptor,
  [BuildTypes.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}

export interface SnackItemDescriberProps {
  snack: GiftItem;
}

export interface ReferralItemDescriberProps {
  referral: Referral;
  isSender: boolean;
}

export interface DealProps {
  expired?: boolean;
  styles?: {[index: string]: {[index: string]: number | string}};
  deal?: GiftItem;
}

export interface HomeLocationProps {
  locationNameText?: string;
  readOrUnreadNotificaton?: boolean;
}

export interface PasswordInpProps {
  maxLength?: number;
}
export interface CollapsibleComponentProps {
  toValue: number;
  toDegree: string;
  content: StyleProp<ViewStyle>;
  parentContainer: StyleProp<ViewStyle>;
}
export interface StylesDescriptor {
  container: StyleProp<ViewStyle>;
  paymentDropDownInputContainer: StyleProp<ViewStyle>;
  paymentInput: StyleProp<TextStyle>;
  input: StyleProp<TextStyle>;
  imageContainer: StyleProp<ViewStyle>;
  labelContainer: StyleProp<ViewStyle>;
  label: StyleProp<TextStyle>;
  error: StyleProp<TextStyle>;
  leftIcon: StyleProp<ViewStyle>;
  help: StyleProp<TextStyle>;
  shadow?: StyleProp<ViewStyle>;
}

export interface NumberSpinnerStylesDescriptor {
  num: StyleProp<ViewStyle>;
  numText: StyleProp<TextStyle>;
}

export interface CommonUtilsSwitchProps {
  switchStatus?: boolean;
  title?: string;
  onSwitchToggle: () => void;
}

export interface RewardsSection {
  styles?: {[index: string]: {[index: string]: number | string}};
}
